'use strict';
module.exports = function () {
    var sizes = ['xs', 'sm', 'md', 'lg', 'xl','xxl'];

    sizes.forEach(function (size) {
        var selector = '.collapsible-' + size + ' .title';
        $('body').on('click', selector, function (e) {
            e.preventDefault();
            $(this).parents('.collapsible-' + size).toggleClass('active');

            if ($(this).parents('.collapsible-' + size).hasClass('active')) {
                $(this).attr('aria-expanded', true);
            } else {
                $(this).attr('aria-expanded', false);
            }
        });
    });

    $('body').on('click', '[data-toggle=collapse-next]', function () {
        var $target = $(this).parent().find('.collapse')
        if ($(this).hasClass('collapsed')) {
            $target.collapse('show');
            $(this).removeClass('collapsed');
            $(this).attr('aria-expanded', true);
        } else {
            $target.collapse('hide');
            $(this).addClass('collapsed');
            $(this).attr('aria-expanded', false);
        }
    });
};
